import { render } from "./index.vue?vue&type=template&id=0fa6ef14&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0fa6ef14&lang=scss&scoped=true"

import exportComponent from "/root/workspace/A01_brandsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa6ef14"]])

export default __exports__